module.exports = __webpack_public_path__ + "img/contact_code_applets@2x.f5ce2bbb.png";